import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import s from './breadcrumb.less';

class Breadcreumb extends React.Component {
  static propTypes = {
    paths: PropTypes.array,
  };

  renderItem = (i, key) => (
    <li key={key}>
      {i.to && <Link to={i.to}>{i.name}</Link>}
      {!i.to && i.name}
    </li>
  );

  render() {
    return (
      <ol className={s.breadcrumb}>{this.props.paths.map(this.renderItem)}</ol>
    );
  }
}
export default Breadcreumb;
